import { Component } from 'react';

/*
 * /#/logout — convenience alias that hands off to the standalone /reset.html page,
 * which does the actual full client reset (IndexedDB redux-persist + session/local
 * storage + service worker) and returns the user to a clean login. Using the static
 * page means the reset still works even if the React app itself is too broken to boot.
 */
export default class Logout extends Component {
    componentDidMount() {
        try {
            window.location.replace('/reset.html');
        } catch (e) {
            window.location.href = '/reset.html';
        }
    }
    render() {
        return null;
    }
}
